import { useEffect, useCallback } from "react";

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from "@/analytics";
import {
    ActionKey,
    ActionSubjectIdKey,
    ActionSubjectKey,
    SourceKey
} from "@/analytics/constants";

export const useLegalConsentPageAnalytics = () => {
    const { identityAttrs } = useFastshiftAnalyticsData();
    const { fireScreenEvent, fireUIEvent } =
        useFireAnalyticsEvents(identityAttrs);

    // Screen Event
    useEffect(() => {
        fireScreenEvent({
            name: SourceKey.FASTSHIFT_PORTAL_LEGAL_CONSENT_SCREEN
        });
    }, [fireScreenEvent]);

    // UI event
    const sendCustomerConsentButtonClickUIEvent = useCallback(() => {
        fireUIEvent({
            action: ActionKey.CLICKED,
            actionSubject: ActionSubjectKey.BUTTON,
            actionSubjectId: ActionSubjectIdKey.LEGAL_CONSENT_BUTTON,
            source: SourceKey.FASTSHIFT_PORTAL_LEGAL_CONSENT_SCREEN
        });
    }, [fireUIEvent]);

    return { sendCustomerConsentButtonClickUIEvent };
};
